import Breadcrumb from "../components/Breadcrumb";
import AddBlogForm from "../components/blog/AddBlogForm";

const EditBlogPage = () => {
  return (
    <>
      <Breadcrumb title="Edit Blog" />
      <AddBlogForm />
    </>
  );
};

export default EditBlogPage;

